
export default {
  staticDomain: "//static.hsappstatic.net" || window.location.host,
  staticDomainPrefix: "//static.hsappstatic.net" || ('//' + window.location.host),
  currentProject: "customer-portal-app",
  currentProjectVersion: "static-1.3551",
  depVersions: {
  "customer-portal-app": "static-1.3551",
  "apollo-dlb": "static-3.98",
  "avatar-components": "static-1.3024",
  "client-types": "static-1.523",
  "data-fetching-client": "static-1.10171",
  "emoji-mart": "static-3.9",
  "enviro": "static-4.529",
  "growth-payments-core": "static-1.26624",
  "head-dlb": "static-1.5344",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.6126",
  "hs-test-utils": "static-1.8578",
  "hub-http": "static-1.6741",
  "hub-http-shared-msw-handlers": "static-1.11002",
  "hubspot-dlb": "static-2.1911",
  "hubspot-prosemirror": "static-1.19397",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.12025",
  "I18n": "static-7.1723",
  "immutable": "static-2.88",
  "jasmine-runner": "static-1.6994",
  "payment-link-components": "static-1.24582",
  "portals-platform-bend-plugin": "static-1.29",
  "prosemirror": "static-1.13",
  "quartz": "static-1.7754",
  "quartz-core": "static-1.6973",
  "quartz-i18n": "static-1.1429",
  "react": "static-7.204",
  "react-colorpicker": "static-2.10745",
  "react-dlb": "static-1.96",
  "react-utils": "static-2.5715",
  "reselect": "static-3.19",
  "rich-text-lib": "static-1.20643",
  "transmute": "static-2.97",
  "ui-addon-upgrades": "static-9.18607",
  "ui-components-test-utils": "static-1.6162",
  "UIComponents": "static-3.8971",
  "video-player-core": "static-1.23",
  "foundations-assets": "static-1.5425",
  "foundations-components": "static-1.8847",
  "foundations-theming": "static-1.5037",
  "foundations-theming-specialty": "static-1.2753",
  "framer-motion": "static-1.86",
  "metrics-js": "static-1.9990",
  "PortalIdParser": "static-2.459",
  "portals-platform-lib": "static-1.1772",
  "pulse": "static-1.1203",
  "quartz-config": "static-1.1532",
  "quartz-routing": "static-1.1184",
  "quick-fetch": "static-1.4265",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.17273",
  "rpc-client-utils": "static-1.5202",
  "sanitize-text": "static-1.8693",
  "styled-components": "static-2.100",
  "tanstack-table": "static-1.68",
  "ui-addon-draggable": "static-3.5288",
  "ui-addon-react-router-dom": "static-1.10064",
  "usage-tracker": "static-1.7878",
  "usage-tracker-anonymous": "static-1.6295",
  "usage-tracker-core": "static-1.7728",
  "video-components-external": "static-1.12547",
  "apollo-stack-hubspot": "static-3.94",
  "hs-promise-rejection-tracking": "static-1.6102",
  "raven": "static-3.6435",
  "raven-hubspot": "static-1.6742",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "moment": "static-3.75",
  "bend-plugin-quartz": "static-1.4031",
  "quartz-webpack": "static-1.3978",
  "bend-plugin-quartz-routing": "static-1.832",
  "hub-http-janus": "static-1.919",
  "hubspotter-http": "static-1.5011",
  "icons": "static-2.715",
  "StyleGuideUI": "static-3.520",
  "trellis-components": "static-1.3273",
  "trellis-migration-context": "static-1.114",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.95",
  "customer-data-objects": "static-1.8250",
  "frontend-preferences-client": "static-1.8459",
  "hs-browser-apis": "static-1.16",
  "laboratory-lib": "static-3.7684",
  "onboarding-scopes": "static-1.6988",
  "seat-types-lib": "static-1.1167",
  "ui-addon-opt": "static-4.8970",
  "HeadJS": "static-2.836",
  "hs-test-utils-bend-plugin": "static-1.3689",
  "msw": "static-1.105",
  "msw-config": "static-1.41",
  "testing-library": "static-1.167",
  "hs-locale-management": "static-1.440",
  "ts-schema": "static-1.4431",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.8503",
  "content-media-capture": "static-1.5884",
  "cssUtils": "static-1.1159",
  "customer-data-ui-utilities": "static-1.10369",
  "file-manager-components": "static-1.24932",
  "HubStyle": "static-2.12332",
  "knowledge-content-types": "static-1.8767",
  "PatternValidationJS": "static-1.3412",
  "react-input-autosize": "static-2.17",
  "ui-addon-emoji-picker": "static-1.10400",
  "ui-addon-i18n": "static-1.11683",
  "ui-business-units-lib": "static-1.9632",
  "ui-shepherd-react": "static-3.10823",
  "video-data-lib": "static-1.36205",
  "i18n-data": "static-1.237",
  "moment-timezone": "static-5.98",
  "jasmine": "static-4.4841",
  "commerce-tours-lib": "static-1.6948",
  "customer-data-properties": "static-1.53247",
  "getting-started-shared-tasks": "static-1.19657",
  "growth-onboarding-reliability": "static-1.5619",
  "onboarding-tours": "static-1.17480",
  "reference-resolvers-lite": "static-1.8649",
  "sales-checkout-service-client": "static-1.4058",
  "ui-addon-iframeable": "static-1.9616",
  "user-context": "static-1.5594",
  "bender-build-tools": "static-1.3648",
  "dispatcher": "static-1.150",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.618",
  "module-federation": "static-1.42",
  "opentelemetry-fe": "static-1.711",
  "quartz-auth": "static-1.1429",
  "quartz-head": "static-1.1419",
  "quartz-test": "static-1.1429",
  "quartz-tracking": "static-1.1133",
  "ui-fonts": "static-1.1287",
  "usage-tracker-container": "static-1.7868",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9960",
  "data-token-picker": "static-1.17222",
  "FileManagerLib": "static-1.40572",
  "property-translator": "static-1.5912",
  "merchandise-lib": "static-1.289",
  "purchase-motions-components": "static-1.6718",
  "SharedI18nStrings": "static-1.190",
  "foundations-components-test-utils": "static-1.6330",
  "react-create-root-preference": "static-1.120",
  "react-select-plus": "static-1.120",
  "react-virtualized": "static-2.114",
  "ui-images": "static-2.1295",
  "bend-plugin-foundations-components": "static-1.5116",
  "floating-ui": "static-1.70",
  "react-aria": "static-1.79",
  "trellis-assets": "static-1.3254",
  "bend-plugin-foundations-theming": "static-1.3520",
  "foundations-theming-base": "static-1.4022",
  "stylex": "static-1.48",
  "interframe": "static-3.5281",
  "js-cookie": "static-1.18",
  "pdf-js": "static-2.49",
  "usage-tracker-multi": "static-1.6292",
  "batch-promise": "static-1.2086",
  "bend-plugin-pulse": "static-1.706",
  "chirp-fetch": "static-1.2436",
  "event-emitter": "static-1.1496",
  "fast-json-patch": "static-1.76",
  "immer": "static-1.107",
  "opentelemetry-fe-types": "static-1.336",
  "beacon-keepalive-queue": "static-1.238",
  "web-vitals": "static-1.21",
  "bend-plugin-chirp-manifest": "static-1.612",
  "autolinker": "static-3.11",
  "sanitize": "static-1.5004",
  "react-flip-move": "static-1.85",
  "apollo-link-hub-http": "static-2.5125",
  "content-media-composition-data-lib": "static-1.13688",
  "content-media-compositions": "static-2.17695",
  "idb-keyval": "static-1.57",
  "immerable": "static-1.4680",
  "magpie-lib": "static-1.5959",
  "magpie-types": "static-1.5419",
  "media-bridge-lib": "static-1.19728",
  "sassPrefix": "static-1.423",
  "base-ui": "static-1.31",
  "react-day-picker": "static-1.17",
  "tanstack-virtual": "static-1.45",
  "trellis-theming": "static-1.1577",
  "inbound-db-properties-service-client": "static-1.4188",
  "superstore": "static-1.5291",
  "feedback-loader": "static-1.30147",
  "ai-components-ui-library": "static-1.10126",
  "ui-addon-video-player": "static-1.9158",
  "ui-coaching-tips": "static-1.29639",
  "ContentUtils": "static-1.69616",
  "fix-webm-duration": "static-1.37",
  "notification-sounds": "static-1.4965",
  "react-dnd-compat": "static-1.5146",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "breeze-engine-lib": "static-1.2384",
  "copilot-toolkit": "static-1.12262",
  "poll-commands": "static-1.4012",
  "atom": "static-1.5609",
  "navigation-messaging": "static-1.8645",
  "redux-thunk": "static-2.87",
  "reference-resolvers": "static-1.8722",
  "commerce-products-lib": "static-1.11089",
  "crm-message-bus": "static-1.44256",
  "growth-data-modal": "static-1.6215",
  "hubspot-apollo-client": "static-1.5412",
  "onboarding-tours-client": "static-1.5695",
  "calling-global-api": "static-1.66503",
  "calling-internal-common": "static-1.31859",
  "calling-lifecycle-internal": "static-1.67885",
  "calling-lifecycle-messages": "static-1.60177",
  "conditional-properties-service-client": "static-1.4148",
  "crm-index-visualization-core": "static-1.4848",
  "crm-links": "static-1.6863",
  "crm-pipelines-api-client-types": "static-1.4482",
  "customer-data-objects-ui-components": "static-1.13572",
  "customer-data-properties-shared-msw-handlers": "static-1.10329",
  "customer-data-property-utils": "static-1.8595",
  "data-agent-utils": "static-1.1060",
  "external-options-client-types": "static-1.4476",
  "formula-editor": "static-1.15082",
  "google-libphonenumber": "static-1.52",
  "hs-resources": "static-1.732",
  "inbound-db-meta-service-client": "static-1.3808",
  "inbounddb-objects-service-types": "static-1.4552",
  "meetings-icalendar-utils-lib": "static-1.1171",
  "multi-currency-client-types": "static-1.4047",
  "object-builder-ui-client": "static-1.50212",
  "pipeline-validation-client-types": "static-1.4320",
  "property-value-citations": "static-1.3861",
  "react-tinymce": "static-1.56370",
  "smart-data-capture-core": "static-1.608",
  "tiered-pricing": "static-1.2386",
  "tinymce-config": "static-2.55496",
  "tinymce-plugins": "static-1.58610",
  "tinymce-themes": "static-1.57466",
  "topics-actions-lib": "static-1.729",
  "trellis-ext-i18n": "static-1.1478",
  "trial-components-library": "static-1.14480",
  "ui-addon-form-validation": "static-1.11352",
  "zustand": "static-1.92",
  "growth-onboarding-confetti": "static-1.3592",
  "growth-onboarding-next-action-utils": "static-1.3095",
  "navigation-components": "static-1.19318",
  "nest": "static-1.774",
  "onboarding-tours-utils": "static-1.1547",
  "ui-shepherd-tracker": "static-1.8204",
  "ui-universal-auth": "static-1.9857",
  "getting-started-shared-tasks-store": "static-1.18775",
  "opentelemetry-web": "static-1.25",
  "hubspotter-http-shared-msw-handlers": "static-1.11000",
  "usage-tracker-session-replay": "static-1.5564",
  "audio-components": "static-1.6650",
  "FileManagerCore": "static-1.40431",
  "FileManagerImages": "static-1.38083",
  "video-components": "static-1.14549",
  "foundations-components-legacy": "static-1.1872",
  "purchase-motions-api": "static-1.6721",
  "signup-constants": "static-1.20111",
  "signup-ui-url-generator": "static-2.8571",
  "stylex-utils": "static-1.190",
  "usage-tracker-public": "static-1.7689",
  "reactive-lib": "static-1.1258",
  "simple-logging-lib": "static-1.3583",
  "nudge-client-utils": "static-1.3508",
  "chatspot-core": "static-1.24266",
  "growth-onboarding-feedback-components": "static-1.7121",
  "cms-field-types": "static-1.5349",
  "content-icons-ui": "static-1.2520",
  "integrations-lib": "static-1.17558",
  "underscore": "static-1.8",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1362",
  "breeze-engine-core": "static-1.1662",
  "highlight.js": "static-1.92",
  "markdown-it": "static-1.6",
  "nav-meta": "static-1.30955",
  "commerce-permissions": "static-1.1319",
  "customer-data-tracking": "static-1.7407",
  "products-iframe-lib": "static-1.9055",
  "products-ui-components-shared-msw-handlers": "static-1.11384",
  "onboarding-data-sync-lib": "static-1.2921",
  "hubspot-apollo-cache": "static-1.871",
  "calling-error-reporting": "static-1.31866",
  "shared-worker-versioning": "static-1.11576",
  "calling-usage-tracker": "static-1.7077",
  "conversations-skeleton-state": "static-1.7649",
  "voice-sms-access-library": "static-1.2607",
  "crm-index-associations-lib": "static-1.6986",
  "redux-toolkit": "static-1.84",
  "sales-views-client-types": "static-1.4794",
  "location-customization-utils-lib": "static-1.10552",
  "data-agent-kit": "static-1.1047",
  "enrichment-settings-lib": "static-1.405",
  "fsm": "static-1.4297",
  "policy-lib": "static-1.7340",
  "bark-lib": "static-1.17070",
  "browser-prettier": "static-1.11",
  "codemirror": "static-5.108",
  "crm-properties-common-lib": "static-1.6433",
  "react-codemirror": "static-1.11178",
  "fdsr-migration-layer": "static-1.549",
  "framework-builder-read-service-client": "static-1.4372",
  "upgrade-components-lib": "static-1.794",
  "tinymce": "static-5.11",
  "hub-http-contrib": "static-1.3566",
  "tinymce-data": "static-1.41581",
  "ui-addon-sales-email": "static-1.5743",
  "layout-dnd-components": "static-1.13317",
  "layout-dnd-utils": "static-1.12292",
  "ui-brand-identity-lib": "static-1.17095",
  "NamespacedHubStyle": "static-2.9405",
  "embedded-academy-lib": "static-1.16193",
  "hubs-service-types": "static-1.1802",
  "salesImages": "static-1.794",
  "growth-onboarding-next-action-components": "static-1.3123",
  "user-context-client": "static-1.5043",
  "custom-vendor-connection-lib": "static-1.421",
  "unified-auth-core-lib": "static-1.1653",
  "amplitude-session-replay-browser": "static-1.79",
  "breeze-artifacts-sdk": "static-1.1200",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.67",
  "urlinator": "static-1.5053",
  "video-embed": "static-1.37039",
  "social-insights-client-types": "static-1.23041",
  "nudge-custom-function-registry": "static-1.3265",
  "nudge-renderer-utils": "static-1.3584",
  "whisper-core-api": "static-1.7734",
  "flux-actions": "static-1.383",
  "integrations-error-boundary-lib": "static-1.14973",
  "integrations-tracking-lib": "static-1.6164",
  "native-integrations-shared-strings": "static-1.8294",
  "redux-observable": "static-1.81",
  "ReduxMessenger": "static-2.10908",
  "rxjs": "static-5.10",
  "InboxConnectUtils": "static-4.15952",
  "meetings-connect-utils-lib": "static-1.8155",
  "calling-orchestration-schema": "static-1.37384",
  "crm-record-cards-service-types": "static-1.3893",
  "highcharts": "static-8.117",
  "trellis-story-utils": "static-1.5032",
  "storybook-react": "static-1.46",
  "diff-match-patch": "static-1.7",
  "react-reducer-toolkit": "static-1.16768",
  "browser-eslint": "static-2.57",
  "persist-promise": "static-1.4243",
  "ContentData": "static-1.69691",
  "layout-data-lib": "static-1.10617",
  "academy-common-lib": "static-1.15654",
  "outpost": "static-1.4662",
  "universal-page-editor-lib": "static-1.3556",
  "advanced-menus-core": "static-1.15908",
  "advanced-menus-lib": "static-1.12638",
  "ExportDialog": "static-6.10910",
  "ui-memberships-settings-lib": "static-1.35325",
  "academy-service-client": "static-1.4229",
  "croppie": "static-2.10",
  "final-form": "static-1.85",
  "SafeStorage": "static-1.4931",
  "trellis-ecosystem": "static-1.7937",
  "crm-record-cards-client": "static-1.224",
  "framework-data-schema-resolvers": "static-1.7430",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15907",
  "simple-menus-lib": "static-1.17424",
  "settings-ui-lib": "static-1.13068",
  "marketplace-ui-apps-core": "static-1.19684",
  "marketplace-ui-common": "static-1.21152",
  "framework-data-schema-quick-fetch": "static-1.7335",
  "developer-experience-shared-components": "static-1.11081",
  "immutable-less": "static-1.5184",
  "marketplace-ui-client-types": "static-1.18559",
  "ui-addon-integrations-directory-panel": "static-2.8485",
  "ui-extensibility-client-types": "static-1.4454",
  "ai-settings-ui-library": "static-1.8685",
  "react-window": "static-1.13",
  "ui-product-approvals-common": "static-1.1805",
  "apps-service-types": "static-1.4144",
  "oauth-service-types": "static-1.4672",
  "simple-data-table": "static-1.3936"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.3551",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "avatar-components": "/avatar-components/static-1.3024",
  "client-types": "/client-types/static-1.523",
  "data-fetching-client": "/data-fetching-client/static-1.10171",
  "emoji-mart": "/emoji-mart/static-3.9",
  "enviro": "/enviro/static-4.529",
  "growth-payments-core": "/growth-payments-core/static-1.26624",
  "head-dlb": "/head-dlb/static-1.5344",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.6126",
  "hs-test-utils": "/hs-test-utils/static-1.8578",
  "hub-http": "/hub-http/static-1.6741",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.11002",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19397",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.12025",
  "I18n": "/I18n/static-7.1723",
  "immutable": "/immutable/static-2.88",
  "jasmine-runner": "/jasmine-runner/static-1.6994",
  "payment-link-components": "/payment-link-components/static-1.24582",
  "portals-platform-bend-plugin": "/portals-platform-bend-plugin/static-1.29",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.7754",
  "quartz-core": "/quartz-core/static-1.6973",
  "quartz-i18n": "/quartz-i18n/static-1.1429",
  "react": "/react/static-7.204",
  "react-colorpicker": "/react-colorpicker/static-2.10745",
  "react-dlb": "/react-dlb/static-1.96",
  "react-utils": "/react-utils/static-2.5715",
  "reselect": "/reselect/static-3.19",
  "rich-text-lib": "/rich-text-lib/static-1.20643",
  "transmute": "/transmute/static-2.97",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18607",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.6162",
  "UIComponents": "/UIComponents/static-3.8971",
  "video-player-core": "/video-player-core/static-1.23",
  "foundations-assets": "/foundations-assets/static-1.5425",
  "foundations-components": "/foundations-components/static-1.8847",
  "foundations-theming": "/foundations-theming/static-1.5037",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2753",
  "framer-motion": "/framer-motion/static-1.86",
  "metrics-js": "/metrics-js/static-1.9990",
  "PortalIdParser": "/PortalIdParser/static-2.459",
  "portals-platform-lib": "/portals-platform-lib/static-1.1772",
  "pulse": "/pulse/static-1.1203",
  "quartz-config": "/quartz-config/static-1.1532",
  "quartz-routing": "/quartz-routing/static-1.1184",
  "quick-fetch": "/quick-fetch/static-1.4265",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.17273",
  "rpc-client-utils": "/rpc-client-utils/static-1.5202",
  "sanitize-text": "/sanitize-text/static-1.8693",
  "styled-components": "/styled-components/static-2.100",
  "tanstack-table": "/tanstack-table/static-1.68",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5288",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.10064",
  "usage-tracker": "/usage-tracker/static-1.7878",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6295",
  "usage-tracker-core": "/usage-tracker-core/static-1.7728",
  "video-components-external": "/video-components-external/static-1.12547",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.6102",
  "raven": "/raven/static-3.6435",
  "raven-hubspot": "/raven-hubspot/static-1.6742",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "moment": "/moment/static-3.75",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.4031",
  "quartz-webpack": "/quartz-webpack/static-1.3978",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.832",
  "hub-http-janus": "/hub-http-janus/static-1.919",
  "hubspotter-http": "/hubspotter-http/static-1.5011",
  "icons": "/icons/static-2.715",
  "StyleGuideUI": "/StyleGuideUI/static-3.520",
  "trellis-components": "/trellis-components/static-1.3273",
  "trellis-migration-context": "/trellis-migration-context/static-1.114",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.95",
  "customer-data-objects": "/customer-data-objects/static-1.8250",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8459",
  "hs-browser-apis": "/hs-browser-apis/static-1.16",
  "laboratory-lib": "/laboratory-lib/static-3.7684",
  "onboarding-scopes": "/onboarding-scopes/static-1.6988",
  "seat-types-lib": "/seat-types-lib/static-1.1167",
  "ui-addon-opt": "/ui-addon-opt/static-4.8970",
  "HeadJS": "/HeadJS/static-2.836",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3689",
  "msw": "/msw/static-1.105",
  "msw-config": "/msw-config/static-1.41",
  "testing-library": "/testing-library/static-1.167",
  "hs-locale-management": "/hs-locale-management/static-1.440",
  "ts-schema": "/ts-schema/static-1.4431",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.8503",
  "content-media-capture": "/content-media-capture/static-1.5884",
  "cssUtils": "/cssUtils/static-1.1159",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10369",
  "file-manager-components": "/file-manager-components/static-1.24932",
  "HubStyle": "/HubStyle/static-2.12332",
  "knowledge-content-types": "/knowledge-content-types/static-1.8767",
  "PatternValidationJS": "/PatternValidationJS/static-1.3412",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10400",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11683",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9632",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10823",
  "video-data-lib": "/video-data-lib/static-1.36205",
  "i18n-data": "/i18n-data/static-1.237",
  "moment-timezone": "/moment-timezone/static-5.98",
  "jasmine": "/jasmine/static-4.4841",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6948",
  "customer-data-properties": "/customer-data-properties/static-1.53247",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19657",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5619",
  "onboarding-tours": "/onboarding-tours/static-1.17480",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8649",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.4058",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9616",
  "user-context": "/user-context/static-1.5594",
  "bender-build-tools": "/bender-build-tools/static-1.3648",
  "dispatcher": "/dispatcher/static-1.150",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.618",
  "module-federation": "/module-federation/static-1.42",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.711",
  "quartz-auth": "/quartz-auth/static-1.1429",
  "quartz-head": "/quartz-head/static-1.1419",
  "quartz-test": "/quartz-test/static-1.1429",
  "quartz-tracking": "/quartz-tracking/static-1.1133",
  "ui-fonts": "/ui-fonts/static-1.1287",
  "usage-tracker-container": "/usage-tracker-container/static-1.7868",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9960",
  "data-token-picker": "/data-token-picker/static-1.17222",
  "FileManagerLib": "/FileManagerLib/static-1.40572",
  "property-translator": "/property-translator/static-1.5912",
  "merchandise-lib": "/merchandise-lib/static-1.289",
  "purchase-motions-components": "/purchase-motions-components/static-1.6718",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.190",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6330",
  "react-create-root-preference": "/react-create-root-preference/static-1.120",
  "react-select-plus": "/react-select-plus/static-1.120",
  "react-virtualized": "/react-virtualized/static-2.114",
  "ui-images": "/ui-images/static-2.1295",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5116",
  "floating-ui": "/floating-ui/static-1.70",
  "react-aria": "/react-aria/static-1.79",
  "trellis-assets": "/trellis-assets/static-1.3254",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3520",
  "foundations-theming-base": "/foundations-theming-base/static-1.4022",
  "stylex": "/stylex/static-1.48",
  "interframe": "/interframe/static-3.5281",
  "js-cookie": "/js-cookie/static-1.18",
  "pdf-js": "/pdf-js/static-2.49",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6292",
  "batch-promise": "/batch-promise/static-1.2086",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.706",
  "chirp-fetch": "/chirp-fetch/static-1.2436",
  "event-emitter": "/event-emitter/static-1.1496",
  "fast-json-patch": "/fast-json-patch/static-1.76",
  "immer": "/immer/static-1.107",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.336",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.238",
  "web-vitals": "/web-vitals/static-1.21",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.612",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.5004",
  "react-flip-move": "/react-flip-move/static-1.85",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5125",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13688",
  "content-media-compositions": "/content-media-compositions/static-2.17695",
  "idb-keyval": "/idb-keyval/static-1.57",
  "immerable": "/immerable/static-1.4680",
  "magpie-lib": "/magpie-lib/static-1.5959",
  "magpie-types": "/magpie-types/static-1.5419",
  "media-bridge-lib": "/media-bridge-lib/static-1.19728",
  "sassPrefix": "/sassPrefix/static-1.423",
  "base-ui": "/base-ui/static-1.31",
  "react-day-picker": "/react-day-picker/static-1.17",
  "tanstack-virtual": "/tanstack-virtual/static-1.45",
  "trellis-theming": "/trellis-theming/static-1.1577",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4188",
  "superstore": "/superstore/static-1.5291",
  "feedback-loader": "/feedback-loader/static-1.30147",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10126",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9158",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29639",
  "ContentUtils": "/ContentUtils/static-1.69616",
  "fix-webm-duration": "/fix-webm-duration/static-1.37",
  "notification-sounds": "/notification-sounds/static-1.4965",
  "react-dnd-compat": "/react-dnd-compat/static-1.5146",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2384",
  "copilot-toolkit": "/copilot-toolkit/static-1.12262",
  "poll-commands": "/poll-commands/static-1.4012",
  "atom": "/atom/static-1.5609",
  "navigation-messaging": "/navigation-messaging/static-1.8645",
  "redux-thunk": "/redux-thunk/static-2.87",
  "reference-resolvers": "/reference-resolvers/static-1.8722",
  "commerce-products-lib": "/commerce-products-lib/static-1.11089",
  "crm-message-bus": "/crm-message-bus/static-1.44256",
  "growth-data-modal": "/growth-data-modal/static-1.6215",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5412",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5695",
  "calling-global-api": "/calling-global-api/static-1.66503",
  "calling-internal-common": "/calling-internal-common/static-1.31859",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67885",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.60177",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4148",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4848",
  "crm-links": "/crm-links/static-1.6863",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4482",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13572",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10329",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8595",
  "data-agent-utils": "/data-agent-utils/static-1.1060",
  "external-options-client-types": "/external-options-client-types/static-1.4476",
  "formula-editor": "/formula-editor/static-1.15082",
  "google-libphonenumber": "/google-libphonenumber/static-1.52",
  "hs-resources": "/hs-resources/static-1.732",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3808",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4552",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1171",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4047",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50212",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4320",
  "property-value-citations": "/property-value-citations/static-1.3861",
  "react-tinymce": "/react-tinymce/static-1.56370",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.608",
  "tiered-pricing": "/tiered-pricing/static-1.2386",
  "tinymce-config": "/tinymce-config/static-2.55496",
  "tinymce-plugins": "/tinymce-plugins/static-1.58610",
  "tinymce-themes": "/tinymce-themes/static-1.57466",
  "topics-actions-lib": "/topics-actions-lib/static-1.729",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1478",
  "trial-components-library": "/trial-components-library/static-1.14480",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11352",
  "zustand": "/zustand/static-1.92",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3592",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.3095",
  "navigation-components": "/navigation-components/static-1.19318",
  "nest": "/nest/static-1.774",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1547",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8204",
  "ui-universal-auth": "/ui-universal-auth/static-1.9857",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18775",
  "opentelemetry-web": "/opentelemetry-web/static-1.25",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.11000",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5564",
  "audio-components": "/audio-components/static-1.6650",
  "FileManagerCore": "/FileManagerCore/static-1.40431",
  "FileManagerImages": "/FileManagerImages/static-1.38083",
  "video-components": "/video-components/static-1.14549",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1872",
  "purchase-motions-api": "/purchase-motions-api/static-1.6721",
  "signup-constants": "/signup-constants/static-1.20111",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8571",
  "stylex-utils": "/stylex-utils/static-1.190",
  "usage-tracker-public": "/usage-tracker-public/static-1.7689",
  "reactive-lib": "/reactive-lib/static-1.1258",
  "simple-logging-lib": "/simple-logging-lib/static-1.3583",
  "nudge-client-utils": "/nudge-client-utils/static-1.3508",
  "chatspot-core": "/chatspot-core/static-1.24266",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7121",
  "cms-field-types": "/cms-field-types/static-1.5349",
  "content-icons-ui": "/content-icons-ui/static-1.2520",
  "integrations-lib": "/integrations-lib/static-1.17558",
  "underscore": "/underscore/static-1.8",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1362",
  "breeze-engine-core": "/breeze-engine-core/static-1.1662",
  "highlight.js": "/highlight.js/static-1.92",
  "markdown-it": "/markdown-it/static-1.6",
  "nav-meta": "/nav-meta/static-1.30955",
  "commerce-permissions": "/commerce-permissions/static-1.1319",
  "customer-data-tracking": "/customer-data-tracking/static-1.7407",
  "products-iframe-lib": "/products-iframe-lib/static-1.9055",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11384",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2921",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.871",
  "calling-error-reporting": "/calling-error-reporting/static-1.31866",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11576",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7077",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7649",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2607",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6986",
  "redux-toolkit": "/redux-toolkit/static-1.84",
  "sales-views-client-types": "/sales-views-client-types/static-1.4794",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10552",
  "data-agent-kit": "/data-agent-kit/static-1.1047",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.405",
  "fsm": "/fsm/static-1.4297",
  "policy-lib": "/policy-lib/static-1.7340",
  "bark-lib": "/bark-lib/static-1.17070",
  "browser-prettier": "/browser-prettier/static-1.11",
  "codemirror": "/codemirror/static-5.108",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6433",
  "react-codemirror": "/react-codemirror/static-1.11178",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.549",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4372",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.794",
  "tinymce": "/tinymce/static-5.11",
  "hub-http-contrib": "/hub-http-contrib/static-1.3566",
  "tinymce-data": "/tinymce-data/static-1.41581",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5743",
  "layout-dnd-components": "/layout-dnd-components/static-1.13317",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12292",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.17095",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9405",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.16193",
  "hubs-service-types": "/hubs-service-types/static-1.1802",
  "salesImages": "/salesImages/static-1.794",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.3123",
  "user-context-client": "/user-context-client/static-1.5043",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.421",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1653",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.79",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.1200",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.67",
  "urlinator": "/urlinator/static-1.5053",
  "video-embed": "/video-embed/static-1.37039",
  "social-insights-client-types": "/social-insights-client-types/static-1.23041",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3265",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3584",
  "whisper-core-api": "/whisper-core-api/static-1.7734",
  "flux-actions": "/flux-actions/static-1.383",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14973",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6164",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8294",
  "redux-observable": "/redux-observable/static-1.81",
  "ReduxMessenger": "/ReduxMessenger/static-2.10908",
  "rxjs": "/rxjs/static-5.10",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15952",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8155",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37384",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3893",
  "highcharts": "/highcharts/static-8.117",
  "trellis-story-utils": "/trellis-story-utils/static-1.5032",
  "storybook-react": "/storybook-react/static-1.46",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16768",
  "browser-eslint": "/browser-eslint/static-2.57",
  "persist-promise": "/persist-promise/static-1.4243",
  "ContentData": "/ContentData/static-1.69691",
  "layout-data-lib": "/layout-data-lib/static-1.10617",
  "academy-common-lib": "/academy-common-lib/static-1.15654",
  "outpost": "/outpost/static-1.4662",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3556",
  "advanced-menus-core": "/advanced-menus-core/static-1.15908",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12638",
  "ExportDialog": "/ExportDialog/static-6.10910",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35325",
  "academy-service-client": "/academy-service-client/static-1.4229",
  "croppie": "/croppie/static-2.10",
  "final-form": "/final-form/static-1.85",
  "SafeStorage": "/SafeStorage/static-1.4931",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7937",
  "crm-record-cards-client": "/crm-record-cards-client/static-1.224",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7430",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15907",
  "simple-menus-lib": "/simple-menus-lib/static-1.17424",
  "settings-ui-lib": "/settings-ui-lib/static-1.13068",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19684",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21152",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7335",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11081",
  "immutable-less": "/immutable-less/static-1.5184",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18559",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8485",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4454",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8685",
  "react-window": "/react-window/static-1.13",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1805",
  "apps-service-types": "/apps-service-types/static-1.4144",
  "oauth-service-types": "/oauth-service-types/static-1.4672",
  "simple-data-table": "/simple-data-table/static-1.3936"
}
};
